// LegendContent.tsx
import type { ColorVisionInteractionMethods, DataSeries } from '@shopify/polaris-viz';
import { InlineStack, Text } from '@shopify/polaris';

export interface LegendContentProps {
  data: DataSeries[];
  colorVisionInteractionMethods: ColorVisionInteractionMethods;
  activeIndex?: number;
  seriesKey?: Set<string>;
  onlyHasTimeDimension?: boolean;
}

export const LegendContent: React.FC<LegendContentProps> = ({
  data,
  colorVisionInteractionMethods,
  seriesKey,
  onlyHasTimeDimension,
}) => {
  return (
    <InlineStack gap="600">
      {data.map((series, index) => {
        const isComparisonSeries = !series.name || !seriesKey?.has(series.name);
        if (!onlyHasTimeDimension && isComparisonSeries) return null;

        return (
          <div
            key={`${series.name}-${index}`}
            {...colorVisionInteractionMethods.getColorVisionEventAttrs(index)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 5,
              cursor: 'pointer',
              ...colorVisionInteractionMethods.getColorVisionStyles(index),
            }}
          >
            <div
              className="w-[8px] h-[8px] rounded-full"
              style={{
                backgroundColor: series.color as string,
              }}
            />
            <Text variant="bodyXs" as="span">
              {series.name}
            </Text>
          </div>
        );
      })}
    </InlineStack>
  );
};
